import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export default function KpiCard({ label, value, hint, icon: Icon, accent = false, testId }) {
  return (
    <Card
      data-testid={testId}
      className={cn(
        "lift rounded-2xl border-border/70",
        accent ? "bg-primary text-primary-foreground" : "bg-card"
      )}
    >
      <CardContent className="p-6">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className={cn("text-[0.65rem] tracking-[0.2em] uppercase", accent ? "text-primary-foreground/70" : "text-muted-foreground")}>
              {label}
            </div>
            <div className="mt-2 text-3xl font-bold tracking-tight">{value}</div>
            {hint ? <div className={cn("mt-1 text-xs", accent ? "text-primary-foreground/70" : "text-muted-foreground")}>{hint}</div> : null}
          </div>
          {Icon ? (
            <div className={cn("h-11 w-11 rounded-2xl grid place-items-center",
              accent ? "bg-primary-foreground/10" : "bg-primary/10 text-primary")}>
              <Icon className="h-5 w-5" strokeWidth={2} />
            </div>
          ) : null}
        </div>
      </CardContent>
    </Card>
  );
}
